import { Table } from '@devexpress/dx-react-grid-material-ui';
import React from 'react';

export const FocusableCell = ({ ...restProps }: any): JSX.Element => {
  return <Table.Cell {...restProps} />;
};
